'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** URI class for parsing URIs */
var URI = function URI(uri) {
  (0, _classCallCheck3.default)(this, URI);

  var a = document.createElement('a');
  a.href = uri;

  this.protocol = a.protocol;
  this.pathname = a.pathname;

  // In postMessage the default port for each protocol is stripped from
  // the event origin. Exclude it so the origins match up.
  var portMatch = this.protocol === 'http:' ? /(:80)$/ : /(:443)$/;
  this.host = a.host.replace(portMatch, '');

  this.origin = this.protocol + '//' + this.host;
};

exports.default = URI;


//////////////////
// WEBPACK FOOTER
// ./node_modules/xfc/lib/lib/uri.js
// module id = 75
// module chunks = 0